
var currentSlideIndices = {};

function openModal(sectionId, index) {
  currentSlideIndices[sectionId] = index - 1; 
  document.getElementById("imageModal-" + sectionId).style.display = "block";
  showSlide(sectionId, currentSlideIndices[sectionId]);
}

function closeModal(sectionId) {
  document.getElementById("imageModal-" + sectionId).style.display = "none";
}


function showSlide(sectionId, n) {
  var slides = document.getElementsByClassName("mySlides-" + sectionId);
  if (n >= slides.length) {
    currentSlideIndices[sectionId] = 0;
  }
  if (n < 0) {
    currentSlideIndices[sectionId] = slides.length - 1;
  }
  for (var i = 0; i < slides.length; i++) {
    slides[i].style.display = "none";
  }
  slides[currentSlideIndices[sectionId]].style.display = "block";
}


function moveSlide(sectionId, n) {
  showSlide(sectionId, currentSlideIndices[sectionId] += n);
}
